import React from 'react';
import { useDestinationTitle } from '@honeycomb/data';
export const useHydrateSearchDestinations = (searchParameters) => {
    const [hydratedSearchParameters, setHydratedSearchParameters] = React.useState(null);
    const { destinations: rawDestinations } = searchParameters || {};
    const { needsHydrating, unhydratedDestinations } = React.useMemo(() => {
        // Check if any destination is missing a title (hydration needed)
        const shouldHydrate = (rawDestinations || []).some((dest) => !(dest === null || dest === void 0 ? void 0 : dest.title));
        // We need to map the type from "FlexibleDestination" to "InputLegacyDestination"
        const mappedDestinations = (rawDestinations || [])
            .filter((dest) => !!dest && !!dest.id && !!dest.type)
            .map(({ id, type }) => ({ id, type }));
        return { needsHydrating: shouldHydrate, unhydratedDestinations: mappedDestinations };
    }, [rawDestinations]);
    useDestinationTitle(unhydratedDestinations, [
        (response) => {
            const { destinations: hydratedDestinations } = response.getDestinationTitleFromId;
            // Merge the hydrated destinations with our original search parameters
            if (searchParameters) {
                setHydratedSearchParameters(Object.assign(Object.assign({}, searchParameters), { destinations: hydratedDestinations }));
            }
        },
    ], !needsHydrating // skip query if we don't need to hydrate
    );
    return hydratedSearchParameters;
};
